import { Button } from "@/components/ui/button";

interface AuthFormButtonProps {
  loading: boolean;
  mode: "signin" | "signup" | "reset" | "update" | "confirmation";
}

export const AuthFormButton = ({ loading, mode }: AuthFormButtonProps) => {
  const getButtonText = () => {
    if (loading) {
      return mode === "signin" ? "Signing in..." :
             mode === "signup" ? "Signing up..." :
             mode === "reset" ? "Sending reset link..." :
             mode === "update" ? "Updating password..." : "";
    }
    return mode === "signin" ? "Sign in" :
           mode === "signup" ? "Sign up" :
           mode === "reset" ? "Send reset link" :
           mode === "update" ? "Update password" : "";
  };

  return (
    <Button
      type="submit"
      disabled={loading}
      className="w-full bg-cso-600 hover:bg-cso-700 text-white py-2 px-4 rounded-md transition-colors"
    >
      {getButtonText()}
    </Button>
  );
};